import { EgretLoadable } from 'egret';
import { authRoles } from '../../../auth/authRoles';

const Tasks = EgretLoadable({
  loader: () => import('./index')
});

const Route = [
  {
    path: '/tasks',
    exact: true,
    component: Tasks,
    auth: authRoles.all,
  }
];

export default Route;
